var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',{attrs:{"label":_vm.label,"fullWidth":_vm.fullWidth}},[(!_vm.editMode)?_c('span',{style:(Object.assign({}, { display: 'inline-block' }, _vm.textStyles)),attrs:{"multiline-label":""}},[_vm._v(_vm._s(_vm.text))]):_vm._e(),(_vm.editMode)?_c('b-input',{style:(Object.assign({}, (_vm.fullWidth
        ? {
            width: '100%'
          }
        : {}))),attrs:{"type":_vm.inputType,"maxlength":_vm.maxlength},model:{value:(_vm.textData),callback:function ($$v) {_vm.textData=$$v},expression:"textData"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }